var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3205 10.459C18.3288 10.3073 18.3329 10.1546 18.3329 10.0008C18.3329 5.39844 14.602 1.66748 9.99959 1.66748C5.39722 1.66748 1.66626 5.39844 1.66626 10.0008C1.66626 14.5303 5.28002 18.2158 9.78167 18.3314M9.99959 5.00081V10.0008L13.1149 11.5585",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 13.6385C17.6773 13.2734 17.8287 12.8934 17.952 12.501M16.25 15.6248C15.8875 16.0482 15.4395 16.5313 15 16.8748M13.0633 17.7539C12.695 17.8996 12.3138 18.0198 11.922 18.1123",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.ad2328c1f39180f3237e3c7dc857bff5.svg";
export { ForwardRef as ReactComponent };